import {InjectionToken} from '@angular/core'

/**
 * The routes are good to be consistent with.
 */
export const LOGIN_PATH = 'login'
export const ADVICE_PATH = 'advice'
export const RTQ_PATH = 'rtq'
export const CUSTOMER_PATH = 'customer'
export const CUSTOMER_START = 'customer-start'
export const MODEL_PORTFOLIO_PATH = 'modelportfolio'
export const USER_ROLE_NAME = 'ir2User'
export const PORTFOLIO_MANAGER_ROLE = 'ir2PfAdmin'
export const IR2_ADMIN_ROLE = 'ir2Admin'

/**
 * User roles, note irUser is being removed in the future
 */
export const USER_ROLES = [USER_ROLE_NAME, 'irUser']

/**
 * Portfolio manager roles, note irPfAdmin is being removed in the future
 */
export const PORTFOLIO_MANAGER_ROLES = [PORTFOLIO_MANAGER_ROLE, 'irPfAdmin']

// The colors in a breakdown chart or table
export const BREAKDOWN_COLORS = ['#1f55a5', '#ef7622', '#518428', '#f5c400', '#e5e5e5']
export const BREAKDOWN_LABELS = ['Aktier', 'Räntor', 'Kassa', 'Övrigt', 'Ej klassificerad']
export const WINDOW = new InjectionToken<Window>('window')
export const MORNINGSTAR_INDEX = new Map<string, string>([
  ['globalBonds', 'F000011P31'],
  ['swedishBonds', 'F000011PMK'],
  ['globalSecurity', 'F00000VPET'],
  ['swedishSecurity', 'F00000T62Q']
])

/**
 * Account type names for discrimination of accounts types in
 * selects boxes. Note names are dependent on what the actual account
 * coming from the BE uses as a value for its type.
 */
export const OAccountTypeNames = {
  FUND_ACCOUNT: 'Fondkonto',
  ESCROW_ACCOUNT: 'Depåkonto',
  INVESTMENT_SAVINGS_ACCOUNT: 'Investeringssparkonto',
  INDIVIDUAL_PENSIONS_SAVINGS_ACCOUNT: 'Individuellt Pensionssparande',
  DEPOSIT: 'Inlåning',
  ENDOWMENT_INSURANCE: 'Kapitalförsäkring'

} as const